import React, { useState } from "react";
import styled from "styled-components";
import { IMAGE_URL } from "../../api/Api";

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px auto;
  max-width: 1000px;
  position: relative;
`;

const Card = styled.div`
  position: relative;
  z-index: ${(props) => (props.hover ? 100 : 1)};
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 22%;
  margin: 10px 0;
  /* On retire overflow: hidden ici pour que DetailCard puisse s'afficher librement */
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

// Ce conteneur va clipper l'image et le footer pour conserver les bords arrondis
const CardContent = styled.div`
  overflow: hidden;
  border-radius: 15px;
  width: 100%;
`;

const CardImage = styled.img`
  width: 100%;
  flex: 1;
  object-fit: cover;
`;

const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${(props) => props.bgColor};
  padding: 20px 0;
  gap: 10px;
`;

const CardTitle = styled.h2`
  font-size: 18px;
  margin: 0;
  color: white;
`;

const CardButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background: #ff4592;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #b61175;
  }
`;

// Carte de détail qui utilise l'image en fond via la prop bgImage
const DetailCard = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(${(props) => (props.show ? "1" : "0.8")});
  width: 350px;
  height: 450px;
  background: url(${(props) => props.bgImage}) center/cover no-repeat;
  border-radius: 15px;
  box-shadow: 0 0 20px #ff4592, 0 0 40px #b61175;
  padding: 20px;
  opacity: ${(props) => (props.show ? "1" : "0")};
  visibility: ${(props) => (props.show ? "visible" : "hidden")};
  transition: all 0.3s ease-in-out;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: white;
  font-family: "Arial", sans-serif;
  overflow: hidden;
  /* Overlay sombre pour améliorer la lisibilité du texte */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 15px;
    z-index: 0;
  }
`;
// Contenu positionné au-dessus de l'overlay dans la carte de détail
const DetailContent = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
`;


const DetailTitle = styled.h3`
  margin: 0;
  font-size: 24px;
  margin-bottom: 10px;
`;

// const DetailPrice = styled.h4`
//   margin: 0;
//   font-size: 20px;
//   margin-bottom: 10px;
//   color: #ff4592;
// `;

const DetailText = styled.p`
  font-size: 14px;
  color: #d1d1d1;
  padding: 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
`;

const openRoute = (id) => {
  window.open(`https://app.toyaloo.africa/aloo/${id}`, "_bank");
};

// Fonction pour générer une couleur aléatoire
const getRandomColor = () => {
  const letters = "01234567";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 8)];
  }
  return color;
};

const CardItem = ({ id, content_json }) => {
  const randomColor = getRandomColor(); // Générer la couleur aléatoire
   const [showDetail, setShowDetail] = useState(false);
    const [hoverTimeout, setHoverTimeout] = useState(null);
  
    const handleMouseEnter = () => {
      if (hoverTimeout) clearTimeout(hoverTimeout);
      setShowDetail(true);
    };
  
    const handleMouseLeave = () => {
      const timeout = setTimeout(() => setShowDetail(false), 300);
      setHoverTimeout(timeout);
    };
  return (
    <Card 
    onMouseEnter={handleMouseEnter} 
    onMouseLeave={handleMouseLeave}
    hover={showDetail}  // On passe cette prop pour augmenter le z-index
    >
      <CardContent>
              <CardImage src={IMAGE_URL + content_json.images} alt={content_json.title} />
              <CardFooter bgColor={randomColor}>
                <CardTitle>{content_json.title}</CardTitle>
                {/* <CardButton onClick={() => openRoute(id)}>Acheter</CardButton> */}
              </CardFooter>
            </CardContent>
      
            {/* Carte de détails futuriste */}
            <DetailCard show={showDetail} bgImage={IMAGE_URL + content_json.images} >
            <DetailContent>
                  <DetailTitle>{content_json.title}</DetailTitle>
                  <DetailText>
                    {content_json.description.slice(0, 300) || "Aucune description disponible."}...
                  </DetailText>
                  <CardButton onClick={() => openRoute(id)}>Jouer</CardButton>
                </DetailContent>
            </DetailCard>
      {/* <CardImage src={IMAGE_URL + content_json.images} alt="Reading kids" />
      <CardFooter bgColor={randomColor}>
        <CardTitle>{content_json.title}</CardTitle>
        <CardDescription>{content_json.description}</CardDescription>
        <CardButton onClick={() => openRoute(id)}>Jouer</CardButton>
      </CardFooter> */}
    </Card>
  );
};

const CardList = ({ items }) => (
  <CardContainer>
    {items.map((item) => (
      <CardItem key={item.id} {...item} />
    ))}
  </CardContainer>
);

export default CardList;
